module.exports = __webpack_public_path__ + "static/media/nss_logo.3cecabdd.jpg";